import { api } from "@/builders/axios";

export function activate_or_deactivate(
  username: string,
  data: { is_active: boolean; reason: string }
) {
  return api.post(`/students/${username}/activate-or-deactivate`, data);
}
